export default {
    workLoadTypes:          { method: 'get',    url: 'work_load_types' },
    workLoadTypeCreate:     { method: 'post',   url: 'work_load_types' },
    workLoadTypeUpdate:     { method: 'put',    url: 'work_load_types/{id}' },
    workLoadTypeDelete:     { method: 'delete', url: 'work_load_types/{id}' },
}